import { BreadcrumbProps } from '@blueprintjs/core'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Filters, TableName } from '../../config'
import { TableHooks } from '../../packages/blueprint-components/src/useTableHooks'
import { Layout } from '../Layout'
import { Columns } from '../table2/ad_grid_columns'
import { AgGridColumnDef, AgGridTable } from '../table2/AgGridTable'
import { SavedFiltersStore } from '../table2/Filter3'
import { TableStore } from '../table2/table_store'

const defaultFilters = [Filters.PortfolioId, Filters.State, Filters.KeywordMatchType]

const mutableFields: string[] = ['state']

export interface TableProps<T> {
    nested?: boolean
    tableHooks: TableHooks<T>
    store: TableStore<T>
    savedFiltersStore: SavedFiltersStore
}

interface CampaignNegativeKeyword {
    keyword_id: number
    campaign_id: number
    profile_id: number
    state: number
    keyword_text: string
    match_type: number
}

export const CampaignNegativeKeywordsTable = observer(
    ({
        nested,
        store,
        savedFiltersStore,
        tableHooks,
    }: TableProps<CampaignNegativeKeyword>): JSX.Element => {
        const breadcrumbs: BreadcrumbProps[] = [{ text: 'Manage' }]

        const cols3 = useMemo(() => {
            return newColumns()
        }, [])

        return (
            <Layout
                breadcrumbs={breadcrumbs}
                primary={TableName.CampaignNegativeKeyword}
                nested={nested}
                params={tableHooks.params}
            >
                <AgGridTable
                    name={TableName.CampaignNegativeKeyword}
                    columns={cols3}
                    tableHooks={tableHooks}
                    store={store}
                    showHeader={false}
                    savedFiltersStore={savedFiltersStore}
                    filters={defaultFilters}
                    selectKey="keyword_id"
                    stableRowId
                    search
                    searchPlaceholder="Search by keyword"
                    columnSelection
                    mutableFields={mutableFields}
                    bulkActions
                    nested={nested}
                />
            </Layout>
        )
    },
)

const newColumns = <T,>(): AgGridColumnDef<T>[] => {
    return [Columns.Select, Columns.Keyword, Columns.ProductAdsCount]
}
